var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ParcelaImovel } from '../../../../../model/ParcelaImovel';
import { ParcelaImovelCadastro } from '../../common/ParcelaImovelCadastro';
import { generateErrorFields, handleScrollTop, useRequerimentoContext } from '../../context/RequerimentoContext';
import { ModoCRUDEnum } from '../../../../../model/enums/ModoCRUDEnum';
import { hasErrors, hasValue } from '../../../../utils/ValidationUtils';
import { Button, Grid } from '@mui/material';
import { DefaultCard } from '../../../../../components/DefaultCard';
import { SimpleTable } from '../../../../../components/SimpleTable/SimpleTable';
import { prettyArea } from '../DadosImovelUsucapiaoRural';
import { SessaoSIGEF } from '../../../../../components/SessaoSIGEF';
import { DadoCartograficoLimitrofe } from '../../../../../model/DadoCartograficoLimitrofe';
import { DadosImovel } from '../../../../../model/DadosImovel';
import { TipoDocumentoEnum } from '../../../../../model/enums/TipoDocumentoEnum';
import { AuthConstants } from '../../../../../util/auth-constants';
import { LocalStorageUtils } from '../../../../../util/LocalStorageUtils';
import { ButtonBox } from '../../../../../components/common';
import { RequerentePf } from '../../../../../model/RequerentePf';
import { TipoParcelaEnum } from '../../../../../components/TipoParcelaEnum';
import { DadosPecasTecParcela } from '../../../../../components/DadosPecasTecParcela';
import { ShowContent } from '../../../../../components/ShowContent';
import { ParcelaCommonForms } from '../../common/ParcelaCommonForms';
import { nonNull, validateRtFields } from '../../../../../util/CommonUtils';
var columnsParcela = function (isSigef) {
    if (isSigef) {
        return [
            { label: 'Código SIGEF da Parcela', value: 'codigoSIGEF' },
            { label: 'Denominação do Imóvel Concedido', value: 'denominacao' },
            { label: 'Área(HA)', value: 'area' },
            { label: 'Município Atual', value: 'municipio' },
            { label: 'Status SIGEF', value: 'statusSigef' },
        ];
    }
    return [
        { label: 'Número da certificação', value: 'numeroCertificacao' },
        { label: 'Denominação da Parcela', value: 'denominacao' },
        { label: 'Área(HA)', value: 'area' },
        { label: 'Município', value: 'municipio' },
    ];
};
export var DadosImovelDecRecLimites = function (_a) {
    // region Constants
    var _b, _c;
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange, requerimentoFieldError = _a.requerimentoFieldError, requerimento = _a.requerimento, onValidate = _a.onValidate, onChange = _a.onChange;
    var _d = useState(__assign(__assign({}, new ParcelaImovel()), { pecasTecnicas: TipoParcelaEnum.SIGEF })), parcelaImovel = _d[0], setParcelaImovel = _d[1];
    var _e = useState(new DadoCartograficoLimitrofe()), dadosCartograficos = _e[0], setDadosCartograficos = _e[1];
    var _f = useRequerimentoContext(), defaultHandleAddParcelaImovel = _f.defaultHandleAddParcelaImovel, recoverData = _f.recoverData, getStatusSigef = _f.getStatusSigef;
    var _g = useState(null), indexSelecionadoParcela = _g[0], setIndexSelecionadoParcela = _g[1];
    var _h = useState('false'), ocupantePossuiConjuge = _h[0], setOcupantePossuiConjuge = _h[1];
    var _j = useState(false), isDisabledBySigef = _j[0], setIsDisabledBySigef = _j[1];
    var _k = useState(ModoCRUDEnum.CREATE), modoParcela = _k[0], setModoParcela = _k[1];
    var _l = useState({}), fieldErrorParcelaImovel = _l[0], setFieldErrorParcelaImovel = _l[1];
    var _m = useState(false), sigefIsOnline = _m[0], setSigefIsOnline = _m[1];
    var _o = useState(__assign(__assign({}, new DadosImovel()), { ocupante: { tipoOcupante: TipoDocumentoEnum.PF } })), dadosImovel = _o[0], setDadosImovel = _o[1];
    var _p = useState(false), possuiRtSigef = _p[0], setPossuiRtSigef = _p[1];
    var _q = useState(TipoParcelaEnum.SIGEF), tipoParcela = _q[0], setTipoParcela = _q[1];
    // endregion
    // region Hooks (useEffect)
    useEffect(function () {
        onValidate === null || onValidate === void 0 ? void 0 : onValidate(handleValidate);
    }, [parcelaImovel, requerimento, requerimentoFieldError, ocupantePossuiConjuge, dadosImovel]);
    useEffect(function () {
        LocalStorageUtils.setEncryptedDataInLocalStorage(AuthConstants.PARCELA_IMOVEL_CACHE, __assign(__assign({}, parcelaImovel), { requerimentoId: requerimento === null || requerimento === void 0 ? void 0 : requerimento.id }));
    }, [parcelaImovel]);
    useEffect(function () {
        LocalStorageUtils.setEncryptedDataInLocalStorage(AuthConstants.DADOS_CARTOGRAFICOS_LIMITROFES_CACHE, __assign(__assign({}, dadosCartograficos), { requerimentoId: requerimento === null || requerimento === void 0 ? void 0 : requerimento.id }));
    }, [dadosCartograficos]);
    useEffect(function () {
        handleInitialize();
    }, []);
    var disabled = useMemo(function () {
        var _a, _b;
        return ((_b = ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length) > 0;
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel, (_c = ((_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) !== null && _b !== void 0 ? _b : [])) === null || _c === void 0 ? void 0 : _c.length]);
    // endregion
    // region Hooks (useMemo)
    var isViewParcela = useMemo(function () {
        return modoParcela === ModoCRUDEnum.VIEW;
    }, [modoParcela]);
    var valuesParcelaImovel = useMemo(function () {
        var _a, _b;
        return ((_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.map(function (parcela) {
            var _a, _b, _c, _d, _e, _f;
            return ({
                numeroCertificacao: (_a = parcela === null || parcela === void 0 ? void 0 : parcela.numeroCertificacao) !== null && _a !== void 0 ? _a : '',
                codigoSIGEF: (_b = parcela === null || parcela === void 0 ? void 0 : parcela.codigoSIGEF) !== null && _b !== void 0 ? _b : '',
                denominacao: (_c = parcela === null || parcela === void 0 ? void 0 : parcela.denominacao) !== null && _c !== void 0 ? _c : '',
                area: (_d = prettyArea(parcela === null || parcela === void 0 ? void 0 : parcela.area)) !== null && _d !== void 0 ? _d : '',
                municipio: (_f = (_e = parcela === null || parcela === void 0 ? void 0 : parcela.municipio) === null || _e === void 0 ? void 0 : _e.nome) !== null && _f !== void 0 ? _f : '',
                statusSigef: getStatusSigef(parcela, sigefIsOnline),
            });
        })) !== null && _b !== void 0 ? _b : []);
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel, getStatusSigef, sigefIsOnline]);
    // endregion
    // region Handlers
    var handleInitialize = function () {
        var _a, _b, _c, _d, _e, _f;
        recoverData(requerimento, setDadosCartograficos, AuthConstants.DADOS_CARTOGRAFICOS_LIMITROFES_CACHE);
        recoverData(requerimento, setParcelaImovel, AuthConstants.PARCELA_IMOVEL_CACHE);
        var first = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a[0];
        var tipo = (_b = first === null || first === void 0 ? void 0 : first.pecasTecnicas) !== null && _b !== void 0 ? _b : TipoParcelaEnum.SIGEF;
        setTipoParcela(tipo);
        setParcelaImovel(function (prev) {
            return __assign(__assign({}, prev), { pecasTecnicas: tipo });
        });
        if (!!(requerimento === null || requerimento === void 0 ? void 0 : requerimento.id) && (requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel)) {
            setDadosImovel(requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel);
        }
        else {
            setDadosImovel(__assign(__assign({}, new DadosImovel()), { ocupante: { tipoOcupante: TipoDocumentoEnum.PF, ocupantePJ: null, ocupantePF: new RequerentePf() } }));
        }
        var possuiConjuge = nonNull((_f = (_e = (_d = (_c = requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel) === null || _c === void 0 ? void 0 : _c.ocupante) === null || _d === void 0 ? void 0 : _d.ocupantePF) === null || _e === void 0 ? void 0 : _e.conjuge) === null || _f === void 0 ? void 0 : _f.cpf);
        setOcupantePossuiConjuge("".concat(possuiConjuge));
    };
    var handleChanges = function (_parcelaImovel) {
        setParcelaImovel(_parcelaImovel);
    };
    var handleAdd = function () {
        defaultHandleAddParcelaImovel({
            indexSelecionadoState: [indexSelecionadoParcela, setIndexSelecionadoParcela],
            valueState: [parcelaImovel, setParcelaImovel],
            valido: handleValidateParcelaImovel(),
            requerimentoState: [requerimento, onChange],
            modoState: [modoParcela, setModoParcela],
            fieldErrorState: [fieldErrorParcelaImovel, setFieldErrorParcelaImovel],
            disableState: [isDisabledBySigef, setIsDisabledBySigef],
            sigefIsOnline: sigefIsOnline,
            showMessage: true,
            defaultBaseValue: __assign(__assign({}, new ParcelaImovel()), { pecasTecnicas: tipoParcela })
        });
    };
    var onHandleEdit = function (index) {
        var _a;
        handleChanges(__assign({}, (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a[index]));
        setModoParcela(ModoCRUDEnum.UPDATE);
        setIndexSelecionadoParcela(index);
        setFieldErrorParcelaImovel({});
        handleScrollTop();
    };
    var onHandleRemove = function (index) {
        var _a;
        var _parcelas = ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.filter(function (it) { var _a; return it !== ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a[index]); })) || [];
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { parcelasImovel: __spreadArray([], _parcelas, true) }));
    };
    var handleValidate = function () {
        var _a;
        var isEmptyParcelaImovel = ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.length) === 0;
        var _reqFieldError = __assign(__assign({}, requerimentoFieldError), { parcelasImovelError: isEmptyParcelaImovel ? 'Ao menos uma parcela do imóvel deve ser informada.' : '' });
        var _fieldError = generateErrorFields([], __assign({}, _reqFieldError));
        if (isEmptyParcelaImovel) {
            handleValidateParcelaImovel();
        }
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign({}, _fieldError));
        return !isEmptyParcelaImovel;
    };
    var handleValidateParcelaImovel = function () {
        var _a, _b;
        var rt = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.responsavelTecnico;
        var _errors = __spreadArray([
            { key: 'codigoSIGEFError', condition: isSigef && !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoSIGEF) },
            { key: 'numeroCertificacaoError', condition: !isSigef && !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.numeroCertificacao) },
            { key: 'denominacaoError', condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.denominacao) },
            { key: 'matriculaError', condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.matricula) },
            { key: 'areaError', condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.area) },
            { key: 'municipioAtualError', condition: !hasValue((_a = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.municipio) === null || _a === void 0 ? void 0 : _a.id) },
            { key: 'comarcaError', condition: !hasValue((_b = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.comarca) === null || _b === void 0 ? void 0 : _b.id) }
        ], validateRtFields(rt), true);
        var _fieldError = generateErrorFields(_errors, __assign({}, fieldErrorParcelaImovel));
        setFieldErrorParcelaImovel(__assign({}, _fieldError));
        return !hasErrors(_fieldError);
    };
    var isSigef = useMemo(function () {
        return tipoParcela === TipoParcelaEnum.SIGEF;
    }, [tipoParcela]);
    var customButtom = function () {
        var labelMode = ModoCRUDEnum.getDescricao(modoParcela);
        return (_jsx(ButtonBox, __assign({ style: { justifyContent: 'center' } }, { children: _jsxs(Button, __assign({ color: "primary", variant: "outlined", onClick: handleAdd }, { children: [labelMode.toUpperCase(), " Parcela ", isSigef ? 'SIGEF' : 'SNCI'] })) })));
    };
    var tableParcelaImovel = useCallback(function () {
        var _a;
        return (_jsx(DefaultCard, __assign({ title: '' }, { children: _jsx(SimpleTable, { error: (_a = requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.parcelasImovelError) !== null && _a !== void 0 ? _a : '', onHandleRemoveItem: onHandleRemove, indexMark: indexSelecionadoParcela !== null && indexSelecionadoParcela !== void 0 ? indexSelecionadoParcela : undefined, onHandleEdit: onHandleEdit, emptyText: "Nenhuma Parcela Inserida", columns: columnsParcela(isSigef), values: valuesParcelaImovel, showOptions: true }) })));
    }, [requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.parcelasImovelError, valuesParcelaImovel, indexSelecionadoParcela, isSigef]);
    var desabledFieldsSigef = useMemo(function () {
        return (sigefIsOnline && isSigef ? possuiRtSigef : false);
    }, [sigefIsOnline, possuiRtSigef, isSigef]);
    var titleCard = useMemo(function () {
        return isSigef ?
            'Informe a(s) parcela(s) do Imóvel Rural em peças técnicas SIGEF'
            : 'Informe a(s) parcela(s) do Imóvel Rural no SNCI';
    }, [isSigef]);
    var handleTipoChange = function (tipo) {
        setTipoParcela(tipo);
        setParcelaImovel(__assign(__assign({}, parcelaImovel), { pecasTecnicas: tipo }));
    };
    // endregion
    return (_jsxs(_Fragment, { children: [_jsx(DefaultCard, __assign({ title: '' }, { children: _jsx(Grid, __assign({ item: true, xs: 12, style: { textAlign: 'left', marginTop: '50px' } }, { children: _jsx(DadosPecasTecParcela, { options: TipoParcelaEnum.getScniSigefOptions(), handleOnChangePecas: function (value) { return handleTipoChange(value); }, setPecasObject: setTipoParcela, pecasObject: tipoParcela, disabled: disabled }) })) })), _jsxs(ParcelaImovelCadastro, __assign({ onChange: function (value) { return handleChanges(__assign({}, value)); }, onFieldErrorChange: function (err) { return setFieldErrorParcelaImovel(__assign({}, err)); }, isEdit: modoParcela === ModoCRUDEnum.UPDATE, isDisabledBySigef: desabledFieldsSigef, fieldError: fieldErrorParcelaImovel, parcelaImovel: parcelaImovel, customButtom: customButtom(), table: tableParcelaImovel(), isView: isViewParcela, handleAdd: handleAdd, showBtnAdd: false }, { children: [_jsx(ShowContent, __assign({ show: isSigef }, { children: _jsx(SessaoSIGEF, { sigefIsOnline: sigefIsOnline, setSigefIsOnline: setSigefIsOnline, usarSigef: true }) })), _jsx(DefaultCard, __assign({ title: titleCard }, { children: _jsx(ParcelaCommonForms, { parcelaState: [parcelaImovel, setParcelaImovel], isEdit: modoParcela === ModoCRUDEnum.UPDATE, rtSigef: [possuiRtSigef, setPossuiRtSigef], fieldError: fieldErrorParcelaImovel, sigefOnline: sigefIsOnline, requerimento: requerimento }) }))] }))] }));
};
